module.exports = __webpack_public_path__ + "assets/img/btn-view-26307678.png";